import { AbstractControl, ValidationErrors } from '@angular/forms';
import * as AddressValidator from 'bo-crypto-address-validator/dist/wallet-address-validator.min.js';

export class CustomValidators {
    static numberValidator(control: AbstractControl): ValidationErrors | null {
        if (control.pristine) {
            return null;
        }
        const NUMBER_REGEXP = /^\d*(\.\d+)?$/;
        control.markAsTouched();
        if (NUMBER_REGEXP.test(control.value)) {
            return null;
        }
        return {
            invalidNumber: true
        };
    }

    static addressValidator(code: string) {
        return (control: AbstractControl) => {
            if (control.pristine) {
                return null;
            }

            if (AddressValidator.validate(control.value, code)) {
                return null;
            } else {
                return {
                    invalidAddress: true
                };
            }
        };
    }

    static noDigits(control: AbstractControl): ValidationErrors | null {
        const DIGITS = /\d+/g;
        if (DIGITS.test(control.value)) {
            return {
                noDigits: true
            };
        }
        return null;
    }

    // TODO: no change of values
    static removeSpaces(control: AbstractControl) {
        if (control && control.value && !control.value.replace(/\s/g, '').length) {
            control.setValue('');
        }
        return null;
    }

    static noSpecialCharacters(control: AbstractControl): ValidationErrors | null {
        const NO_SPECIAL_CHARACTERS = /^[A-Za-z0-9]*$/;
        if (NO_SPECIAL_CHARACTERS.test(control.value)) {
            return null;
        }
        return {
            noSpecialCharacters: true
        };
    }

    static latinDigitsSpace(control: AbstractControl): ValidationErrors | null {
        const NO_SPECIAL_CHARACTERS_WITH_SPACE = /^[A-Za-z0-9\s]*$/;
        if (NO_SPECIAL_CHARACTERS_WITH_SPACE.test(control.value)) {
            return null;
        }
        return {
            latinDigitsSpace: true
        };
    }

    static latin(control: AbstractControl): ValidationErrors | null {
        // latin alphabet with numbers and special symbols + space
        const LATIN = /^[-._!"`'#%&,:;<>=@{}~\$\(\)\*\+\/\\\?\[\]\^\|a-zA-Z0-9\s]+$/;
        if (LATIN.test(control.value)) {
            return null;
        }
        return {
            latin: true
        };
    }

    static numbersAndLetters(control: AbstractControl): ValidationErrors | null {
        const REGEX = /^(?=.*[0-9])(?=.*[a-zA-Z])(.+)$/;
        if (REGEX.test(control.value)) {
            return null;
        }
        return {
            numbersAndLetters: true
        };
    }

    static upperLowerCases(control: AbstractControl): ValidationErrors | null {
        const REGEX = /^(?=.*[a-z])(?=.*[A-Z])(.+)$/;
        if (REGEX.test(control.value)) {
            return null;
        }
        return {
            upperLowerCases: true
        };
    }
}
